import { render, staticRenderFns } from "./activities.vue?vue&type=template&id=6141bddc&scoped=true&"
import script from "./activities.vue?vue&type=script&lang=js&"
export * from "./activities.vue?vue&type=script&lang=js&"
import style0 from "./activities.vue?vue&type=style&index=0&id=6141bddc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6141bddc",
  null
  
)

export default component.exports